// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "液压与气压传动",
      "tec": "李玉秀",
      "week": "1-8周",
      "add": "教学楼A座417机械"
    },
    {
      "sub": "机械工程材料",
      "tec": "姜壹夫",
      "week": "1-6周",
      "add": "教学楼A座318机械"
    },
    {
      "sub": "科技文献检索",
      "tec": "张岚",
      "week": "1-4周",
      "add": "教学楼A座420机械"
    },
    0,
    {
      "sub": "就业创业指导",
      "tec": "杨贺光",
      "week": "1-5周",
      "add": "教学楼C座112教务"
    }
  ],
  "2": [
    {
      "sub": "电气控制与PLC",
      "tec": "孟海星",
      "week": "2-9周",
      "add": "教学楼A座419机械"
    },
    {
      "sub": "模具设计与制造",
      "tec": "李震帅",
      "week": "1-8周",
      "add": "教学楼A座422机械"
    },
    0,
    {
      "sub": "数控加工工艺与编程",
      "tec": "李铁钢王海飞",
      "week": "1-8周",
      "add": "教学楼A座317机械"
    },
    {
      "sub": "CAD/CAM技术基础",
      "tec": "王炳达",
      "week": "1-8周",
      "add": "教学楼A座215机房"
    }
  ],
  "3": [
    {
      "sub": "机械工程材料",
      "tec": "姜壹夫",
      "week": "1-6周",
      "add": "教学楼A座318机械"
    },
    {
      "sub": "液压与气压传动",
      "tec": "李玉秀",
      "week": "1-8周",
      "add": "教学楼A座417机械"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "CAD/CAM技术基础",
      "tec": "王炳达",
      "week": "1-8单周",
      "add": "教学楼A座215机房"
    },
    {
      "sub": "电气控制与PLC",
      "tec": "孟海星",
      "week": "2-9周",
      "add": "教学楼A座419机械"
    },
    {
      "sub": "工程有限元与数值计算",
      "tec": "郝杰",
      "week": "1-8周",
      "add": "教学楼A座215机房"
    },
    {
      "sub": "人工智能概论",
      "tec": "张悦",
      "week": "1-8周",
      "add": "教学楼C座210教务"
    },
    0
  ],
  "5": [
    {
      "sub": "液压与气压传动",
      "tec": "李玉秀",
      "week": "1-8周",
      "add": "教学楼A座417机械"
    },
    {
      "sub": "数控加工工艺与编程",
      "tec": "李铁钢王海飞",
      "week": "1-8单周",
      "add": "教学楼A座419机械"
    },
    {
      "sub": "工业机器人技术与应用",
      "tec": "张国伟",
      "week": "1-8周",
      "add": "教学楼A座318机械"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
